import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const IsFullscreen = createContext(false);
IsFullscreen.displayName = "IsFullscreen";
function useIsFullscreen() {
  const isFullscreen = useContext(IsFullscreen);
  if (isFullscreen == null) {
    throw new Error("useIsFullscreen called without a IsFullscreen.Provider");
  }
  return isFullscreen;
}
function IsFullscreenProvider({ children, value = false }) {
  return /* @__PURE__ */jsx(IsFullscreen.Provider, { value, children });
}
export {
  IsFullscreen,
  IsFullscreenProvider,
  useIsFullscreen };
//# sourceMappingURL=dist/components/VideoContextProvider/context/state/isFullscreen.js.map